<template>
  <div id="app">
    <GoogleAuth>
      <router-view/>
    </GoogleAuth>
  </div>
</template>

<script>
import GoogleAuth from '@shared/components/GoogleAuth.vue'

export default {
  components: {
      GoogleAuth,
    },
}
</script>

<style>
html {
  scroll-behavior: smooth;
}
.container {
  /* padding: 48px 32px !important; */
}
*:focus {
  outline: 0;
}
</style>